import { jsx as _jsx } from "react/jsx-runtime";
import { reportErrorToBugsnag } from "@air/utils-error";
import { createContext, memo, useCallback, useContext, useMemo, useRef, useState } from "react";
import { isDevOrTestStage } from "~/swr-hooks/utils";
const DEFAULT_VALUE = {
    scale: 1,
    updateScale: ()=>{},
    updatePDFControls: ()=>{}
};
const PDFZoomContext = /*#__PURE__*/ createContext(DEFAULT_VALUE);
export const PDFZoomProvider = /*#__PURE__*/ memo((param)=>{
    let { children } = param;
    const [scale, setScale] = useState(1);
    const updateScaleRef = useRef(null);
    const handleUpdateScale = useCallback((newScale)=>{
        var _updateScaleRef_current;
        setScale(newScale);
        (_updateScaleRef_current = updateScaleRef.current) === null || _updateScaleRef_current === void 0 ? void 0 : _updateScaleRef_current.call(updateScaleRef, newScale);
    }, []);
    const updatePDFControls = useCallback((controls)=>{
        setScale(controls.scale);
        updateScaleRef.current = controls.updateScale;
    }, []);
    const contextValue = useMemo(()=>({
            scale,
            updateScale: handleUpdateScale,
            updatePDFControls
        }), [
        scale,
        handleUpdateScale,
        updatePDFControls
    ]);
    return /*#__PURE__*/ _jsx(PDFZoomContext.Provider, {
        value: contextValue,
        children: children
    });
});
PDFZoomProvider.displayName = "PDFZoomProvider";
export const usePDFZoomContext = ()=>{
    const context = useContext(PDFZoomContext);
    if (context === DEFAULT_VALUE) {
        const error = "usePDFZoomContext must be used within a PDFZoomProvider";
        if (isDevOrTestStage()) {
            throw new Error(error);
        } else {
            reportErrorToBugsnag({
                error,
                context: error
            });
        }
    }
    return context;
};
